import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-logo">
          <h2>JIRA AC Generator</h2>
          <p>Generate your Acceptance criteria for your user stories within minutes.</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© 2024 JIRA AC Generator. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
